import { QueryHookOptions, useQuery } from '@apollo/client'
import {
  getPatientProfile,
  getPatientProfileVariables,
} from '../../models/graphqlTypes'
import { GET_PATIENT_PROFILE } from '../../operations'

type PatientProfileData = getPatientProfile['getPatientProfile']

type Options = QueryHookOptions<getPatientProfile, getPatientProfileVariables>

type Return = {
  data?: PatientProfileData
  refetch: () => void
  loading: boolean
}

export const usePatientProfile = (options: Options = {}): Return => {
  const { data, refetch, loading } = useQuery<
    getPatientProfile,
    getPatientProfileVariables
  >(GET_PATIENT_PROFILE, {
    skip: !options.variables?.patientId,
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
    ...options,
  })

  return { data: data?.getPatientProfile, refetch, loading }
}
